import React from "react";
import { useTranslation } from "react-i18next";
import InfoItem from "./components/infoItem";

function InfosPage() {
  const { t } = useTranslation("global");
  
  const values = [
    { titre: t("info.titre1"), content: t("info.content1") },
    { titre: t("info.titre2"), content: t("info.content2") },
    { titre: t("info.titre3"), content: t("info.content3") },
    { titre: t("info.titre4"), content: t("info.content4") }
  ];

  return (
    <>
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-b from-blue-800 to-blue-900 text-white">
        <div className="container mx-auto px-4">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold mb-6">
              {t("header.about")}<span className="text-blue-300">ISOeVAL</span>
            </h1>
            <p className="text-xl text-blue-100 mb-8">
              {t("info.heroSubtitle", "Votre partenaire pour l'évaluation de conformité et l'amélioration continue")}
            </p>
            <div className="w-20 h-1 bg-blue-300 mx-auto"></div>
          </div>
        </div>
      </section>
      
      {/* About Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-12">
            <div className="md:w-3/5 space-y-6">
              <h2 className="text-3xl font-heading font-bold text-blue-900">
                {t("info.aboutTitle", "Notre Histoire")}
              </h2>
              <div className="w-20 h-1 bg-blue-600"></div>
              <p className="text-lg text-gray-700">
                {t("info.about1")}
              </p>
            </div>
            
            <div className="md:w-2/5">
              <div className="relative w-80 h-80 mx-auto">
                {/* Background circle */}
                <div className="absolute w-64 h-64 bg-blue-100 rounded-full -top-10 -left-10 opacity-40"></div>
                
                {/* Central ISO logo/emblem */}
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-40 h-40 bg-white rounded-full shadow-xl flex items-center justify-center z-20">
                  <div className="w-32 h-32 bg-gradient-to-br from-blue-600 to-blue-800 rounded-full flex items-center justify-center">
                    <div className="text-white font-bold text-4xl">ISO</div>
                  </div>
                </div>
                
                {/* Rotating Standards */}
                <div className="absolute inset-0">
                  {/* ISO Standard 1 */}
                  <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-4 w-24 h-16 bg-blue-50 rounded-lg shadow-lg flex items-center justify-center border-2 border-blue-200 z-10">
                    <div className="text-blue-800 font-bold text-sm">ISO 9001</div>
                  </div>
                  
                  {/* ISO Standard 2 */}
                  <div className="absolute top-1/2 right-0 transform translate-x-4 -translate-y-1/2 w-24 h-16 bg-blue-50 rounded-lg shadow-lg flex items-center justify-center border-2 border-blue-200 z-10">
                    <div className="text-blue-800 font-bold text-sm">ISO 14001</div>
                  </div>
                  
                  {/* ISO Standard 3 */}
                  <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-4 w-24 h-16 bg-blue-50 rounded-lg shadow-lg flex items-center justify-center border-2 border-blue-200 z-10">
                    <div className="text-blue-800 font-bold text-sm">ISO 27001</div>
                  </div>
                  
                  {/* ISO Standard 4 */}
                  <div className="absolute top-1/2 left-0 transform -translate-x-4 -translate-y-1/2 w-24 h-16 bg-blue-50 rounded-lg shadow-lg flex items-center justify-center border-2 border-blue-200 z-10">
                    <div className="text-blue-800 font-bold text-sm">ISO 45001</div>
                  </div>
                </div>
                
                {/* Connection lines */}
                <div className="absolute inset-0">
                  <svg className="w-full h-full" viewBox="0 0 200 200">
                    {/* Connection lines to standards */}
                    <line x1="100" y1="100" x2="100" y2="20" stroke="#90cdf4" strokeWidth="2" strokeDasharray="4" />
                    <line x1="100" y1="100" x2="180" y2="100" stroke="#90cdf4" strokeWidth="2" strokeDasharray="4" />
                    <line x1="100" y1="100" x2="100" y2="180" stroke="#90cdf4" strokeWidth="2" strokeDasharray="4" />
                    <line x1="100" y1="100" x2="20" y2="100" stroke="#90cdf4" strokeWidth="2" strokeDasharray="4" />
                  </svg>
                </div>
                
                {/* Decorative elements */}
                <div className="absolute top-1/4 right-1/4 w-8 h-8 bg-blue-200 rounded-full opacity-60"></div>
                <div className="absolute bottom-1/4 left-1/4 w-12 h-12 bg-blue-300 rounded-full opacity-40"></div>
                
                {/* Checkmark badges */}
                <div className="absolute top-12 right-12 w-10 h-10 bg-green-100 rounded-full flex items-center justify-center shadow-md">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                
                <div className="absolute bottom-16 right-20 w-8 h-8 bg-green-100 rounded-full flex items-center justify-center shadow-md">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Vision & Mission Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-heading font-bold text-blue-900">
              {t("info.visionMissionTitle", "Vision & Mission")}
            </h2>
            <p className="text-gray-600 max-w-3xl mx-auto mt-4">
              {t("info.visionMissionSubtitle", "Ce qui nous guide et comment nous le réalisons")}
            </p>
            <div className="w-20 h-1 bg-blue-600 mx-auto mt-4"></div>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            <InfoItem
              headerOne={t("info.OUR")}
              headerTwo={t("info.VISION")}
              description={t("info.vision")}
            />
            <InfoItem
              headerOne={t("info.OUR")}
              headerTwo={t("info.missionHeader", "Mission")}
              description={t("info.mission")}
            />
          </div>
        </div>
      </section>
      
      {/* Values Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-heading font-bold text-blue-900">
              {t("info.NOS")} <span className="text-blue-600">{t("info.VALUES")}</span>
            </h2>
            <p className="text-gray-600 max-w-3xl mx-auto mt-4">
              {t("info.valuesSubtitle", "Les principes qui guident nos actions et nos décisions au quotidien")}
            </p>
            <div className="w-20 h-1 bg-blue-600 mx-auto mt-4"></div>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-xl shadow-md overflow-hidden">
              <div className="grid md:grid-cols-2 gap-6 p-8">
                {values.map((value, index) => (
                  <div key={index} className="bg-gray-50 p-6 rounded-lg border-l-4 border-blue-500">
                    <h3 className="text-xl font-heading font-bold text-blue-900 mb-3">
                      {value.titre}
                    </h3>
                    <p className="text-gray-700">
                      {value.content}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section className="py-12 bg-gradient-to-r from-blue-600 to-blue-800">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-6">
            {t("info.ctaTitle", "Prêt à commencer votre parcours vers la conformité?")}
          </h2>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto mb-8">
            {t("info.ctaText", "Découvrez comment ISOeVAL peut vous aider à atteindre vos objectifs de conformité et d'amélioration continue.")}
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <a
              href="contact"
              className="bg-white text-blue-700 hover:bg-blue-50 py-3 px-8 rounded-full font-heading font-bold transition-all"
            >
              {t("contact.contact")}
            </a>
            <a
              href="demo"
              className="bg-transparent border-2 border-white text-white hover:bg-white/10 py-3 px-8 rounded-full font-heading font-bold transition-all"
            >
              {t("header.demo")}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default InfosPage;